import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { RoleApi } from 'api';
import { RoleScope, UpdateRoleType } from 'types';

function useUpdate(scope: RoleScope) {
  const queryClient = useQueryClient();
  return useAuthMutation(
    ({ id, ...data }: UpdateRoleType & { id: number }) =>
      RoleApi.put(scope, id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
      },
    },
  );
}

export default useUpdate;
